//import '@babel/polyfill';

// Vue
import Vue from 'vue';
import App from './App';

// 设置
import setting from './setting';

// 混合
import mixinApp from './mixins/app';
import mixinPage from './mixins/page';

// 插件
import plugins from './plugins';

// store
import store from './store';

// iView 和 iView Pro
import ViewUI from 'view-design';
import iViewPro from './libs/iview-pro/iview-pro.min.js';

// 菜单和路由
import router from './router';
import menuHeader from './menu/header';
import menuSider from './menu/sider';

// 多语言
import i18n from './i18n';

// 方法
import { getHeaderName, getMenuSider, getSiderSubmenu } from './libs/system';

// 组件
import Copyright from './components/copyright';
import Link from './components/link';
import RichEditor from './components/richEditor';
import DialogSelect from './components/input/dialog-select';
import ItemSelect from './components/input/item-select';
import UploadAttachment from './components/upload/upload-attachment';
import UploadImage from './components/upload/upload-image';
import FileUpload from './components/upload/file-upload';
import ViewForm from './components/view/view-form';
import ViewTable from './components/view/view-table';
import ViewChart from './components/view/view-chart';
import ModalForm from './components/view/modal-form';
import ModalTable from './components/view/modal-table';
import FormSetting from './components/view/form-setting';
import FormSettingLayout from './components/view/form-setting-layout';
import TableSetting from './components/view/table-setting';
import ModalFormFilter from './components/view/modal-form-filter';
import ModalFormSort from './components/view/modal-form-sort';
import Shortcut from './components/home/shortcut';
import Notice from './components/home/notice';

// API
import modelApi from './api/model';
import dataSourceApi from './api/dataSource';
import taskApi from './api/task';
import applicationApi from './api/application';

// 使用样式，修改主题可以在 styles 目录下创建新的主题包并修改 iView 默认的 less 变量
// 参考 https://www.iviewui.com/docs/guide/theme
import './styles/index.less';
import './libs/iview-pro/iview-pro.css';

// 默认css
import './styles/css/default.css';

// fa图标
import '@fortawesome/fontawesome-free/css/all.min.css';

// CKEditor
import ckEditor from 'ckeditor4-vue';

// 指令
import focus from './directive/focus';
import tabHide from './directive/tabHide';

// 动态路由
import dynamicRouter from './router/dynamic';

// 基础布局
import basicLayout from './layouts/basic-layout';

// libs
import lodop from './libs/lodop';
import * as echarts from 'echarts';
import request from './libs/request';
import util from './libs/util';

const components = {
  Copyright,
  RichEditor,
  DialogSelect,
  ItemSelect,
  UploadAttachment,
  UploadImage,
  FileUpload,
  ViewForm,
  ViewTable,
  ViewChart,
  ModalForm,
  ModalTable,
  FormSetting,
  FormSettingLayout,
  TableSetting,
  ModalFormFilter,
  ModalFormSort,
  Shortcut,
  Notice,
  iLink: Link
};

const install = function (Vue) {
  if (install.installed) return;
  //locale.use(opts.locale);
  //locale.i18n(opts.i18n);

  if (window) window.$t = (key, value) => i18n.t(key, value);

  Vue.use(plugins);
  Vue.use(ViewUI, {
    i18n: (key, value) => i18n.t(key, value)
  });

  Vue.mixin(mixinApp);

  Vue.use(iViewPro);
  Vue.use(ckEditor);

  // 组件
  Object.keys(components).forEach(key => {
    Vue.component(key, components[key]);
  });

  // 指令，自动获得焦点
  Vue.directive('focus', focus);
  // 指令，隐藏Tab标签，保留内容
  Vue.directive('tab-hide', tabHide);

  // eCharts图表
  Vue.prototype.$echarts = echarts;
};

// auto install
// if (typeof window !== 'undefined' && window.Vue) {
//     install(window.Vue);
// }

const API = {
  version: process.env.VERSION,
  // locale: locale.use,
  // i18n: locale.i18n,
  install
  //...components
};

// 页面
const files = require.context('./pages', true, /\.vue$/);
const pages = {};

files.keys().forEach(key => {
  pages[key.replace(/(\.\/)/g, '')] = files(key).default;
});

const created = async (routes, frameInRoutes, pages, layout, vue) => {
  // 加载多语言
  await store.dispatch('admin/i18n/load', vue);
  // 加载用户登录的数据
  await store.dispatch('admin/account/load');
  // 初始化静态路由
  routes.forEach(route => {
    router.addRoute(route);
  });
  // 初始化动态路由
  let dynamicRoutes = await dynamicRouter.init(router, pages, layout);
  // 处理路由 得到每一级的路由设置
  store.commit('admin/page/init', [...frameInRoutes, ...dynamicRoutes]);
  // 设置顶栏菜单
  store.commit('admin/menu/setHeader', menuHeader);
  // 加载边栏菜单
  store.dispatch('admin/menu/loadSider');
  // 初始化全屏监听
  store.dispatch('admin/layout/listenFullscreen');

  // 所有页面
  Vue.prototype.$pages = pages;
};

const routeChanged = to => {
  setTimeout(() => {
    const path = to.path;
    let menu = menuSider;
    if (store.state.admin.setting.dynamicSiderMenu) {
      menu = store.getters['admin/menu/sider'];
    }

    let permissions = store.getters['admin/permission/permission'];

    // 权限判断
    if (to.path != '/login' && to.path != '/home' && !allow(menu, to.path) && permissions[to.path.substr(1)] != true) {
      router.push('/home');
    }

    const headerName = getHeaderName(path, menu);
    // 在 404 时，是没有 headerName 的
    //if (headerName !== null) {
    store.commit('admin/menu/setHeaderName', headerName);

    const filterMenuSider = getMenuSider(menu, headerName);
    store.commit('admin/menu/setSider', filterMenuSider);
    store.commit('admin/menu/setActivePath', path);

    const openNames = getSiderSubmenu(path, menu);
    store.commit('admin/menu/setOpenNames', openNames);
    //}

    //this.appRouteChange(to, from);
  });
};

const allow = (menus, path) => {
  for (let menu of menus) {
    if (menu.path == path) {
      return true;
    }

    if (menu.children && menu.children.length > 0) {
      if (allow(menu.children, path) == true) {
        return true;
      }
    }
  }

  return false;
};

export default API;

export { pages, Vue, App, router, store, i18n, setting, basicLayout, lodop, request, mixinPage, modelApi, dataSourceApi, applicationApi, taskApi, util, created, routeChanged };
